module.exports = __webpack_public_path__ + "img/full7-min.f8437672.png";